import axiosInstance from '../config/axios';
import type { APIResp } from '../types/APIService';

export async function fetchHolidays(): Promise<string[]> {
  try {
    const res = await axiosInstance.get<APIResp<string[]>>(`/holidays`);
    return res.data.data;
  }
  catch {
    return [];
  }
}
